import { Controller } from '@hotwired/stimulus';

import { dispatchIslandNavigate } from '../../features/echo/islands';
import { isSelectionInteraction } from '../selectionInteraction';

export default class extends Controller {
  onSelectionInteraction(e: KeyboardEvent) {
    if (this.disabled) {
      return;
    }
    if (isSelectionInteraction(e) && (e.target as HTMLElement).nodeName !== 'A') {
      const currentTarget = e.currentTarget as HTMLElement;
      dispatchIslandNavigate(currentTarget.dataset.href || '');
    }
  }

  get disabled() {
    return this.data.get('disabled') === 'true';
  }
}
